<template>
	<div id="Flux360">
		<div class="render-level">
			<RenderController/>
			<Renderer class="full-screen">
				<PanoramaScene/><!-- Add "debug" to the tag to enable debug mode -->
			</Renderer>
		</div>
		<div class="ui-level" style="background: transparent; display: none; pointer-events: none;">
			<!--PanoramaSceneUI /-->
		</div>
	</div>
</template>

<style>
#Flux360{
	transition: opacity .2s ease-in;
}
.full-screen {
	height: 100% !important;
	width: 100% !important;
}

.render-level {
	position: absolute;
	width: 100%;
	height: 100%;
}

.ui-level {
	position: absolute;
	right: 0px;
	top: 0px;
	width: 20% !important;
	height: 100% !important;
}
.title {
    font-size: 1em !important;
    text-align: left !important;
    line-height: 1.2 !important;
    margin-bottom: 0px !important;
}
</style>

<script>
import Renderer from "@/components/babylonjs/Renderer";
import PanoramaScene from "./PanoramaScene";
import RenderController from "@/components/babylonjs/RenderController";
import PanoramaSceneUI from "./PanoramaSceneUI";
import {errorHandler} from "@/store/error-handler";
import {mapGetters, mapState, mapMutations} from 'vuex'

export default {
	components: {Renderer, PanoramaScene, PanoramaSceneUI, RenderController},
	data: () => ({
		queryParameterSituationID: "situationID",
		queryParameterSessionID: "sessionID",
		automaticTitle: true,
        firstTitleChange: true
	}),
	computed: {
		...mapGetters(['localUser', 'events', 'commands', 'users', 'panoramaTour', 'appVersion','panoramaTourZIP','panoramaTourZIPEN','showLanguageSelection']),
    	...mapState(['openTokTest']),
		myUsers() {
			return this.$store.state.users;
		}
	},
	timers: {
		housekeeping: { time: 1000, autostart: true, repeat: true },
		networkSync: { time: 100, autostart: true, repeat: true }
    },
	created(){
		console.log("***********************************************");
		console.log("Flux360::Version " + this.$store.getters.appVersion);
		console.log("Flux360::Starting up");
		this.decodeURL();

		this.$store.watch((state, getters) => getters.currentSituation, (newValue, oldValue) => {
			this.handleSituationChange( oldValue, newValue );
		});	

		window.onpopstate = this.onPopState.bind(this);

		this.$store.dispatch('loadLocalConfiguration').then( () => {
			if(this.panoramaTourZIP && !this.showLanguageSelection){
				let zip = this.panoramaTourZIPEN ? (navigator.language || navigator.userLanguage).includes('de') ? this.panoramaTourZIP : this.panoramaTourZIPEN: this.panoramaTourZIP;
				this.$store.dispatch('loadPanoramaTour', {zip: zip, preview: false}).then(() => {
					console.log("Data from CMS is loaded!");
				}).catch(errorHandler);
			}
		});

		console.log("Flux360::Setup complete");
	},
	methods: {
		...mapMutations(["handleGotoSituationTransition","overwriteStartSituationID","setSessionID"]),
		onPopState() {
			this.handleGotoSituationTransition({
				situationID: event.state.situationID, 
				rotation: event.state.rotation ? event.state.rotation : undefined
			}); 			
		},
		decodeURL() {
        	let search_params = new URL(window.location).searchParams;
        	if(search_params.get(this.queryParameterSituationID)) 
				this.overwriteStartSituationID({situationID: search_params.get(this.queryParameterSituationID)});
        
			if(search_params.get(this.queryParameterSessionID))
				this.setSessionID(search_params.get(this.queryParameterSessionID));
		},
		handleSituationChange(oldValue, newValue){
			const situation = newValue;
			if( !situation )
				return;

			if(this.firstTitleChange === true ){
            	if ( (document.title !== null && document.title.value === "") || (document.title==="Flux 360�") ){
                	this.automaticTitle = true;
            	}
            	else{
                	this.automaticTitle = false;
            	}
            	this.firstTitleChange = false;
        	}
        	if(this.automaticTitle === true){
            	if(this.panoramaTour.getName() !== "unnamed"){
                	document.title= this.panoramaTour.getName();
            	}
            	if(situation.getName() !== "unnamed"){
	                document.title += situation.getName();
            	} 
            	if( (this.panoramaTour.getName() === "unnamed") && (situation.getName() === "unnamed")){
	                document.title = "Flux Panoramatour";
            	}
            	console.log("Title: " + document.title);
        	}
        
			let flux360State = { situationID: situation.getID() };
        	let originalURL = new URL(window.location);
			let search_params = originalURL.searchParams;
			//console.log("Handle Situation Change to " + situation.getID() + " Situation ID in query is " + search_params.get(this.queryParameterSituationID));
        	if( search_params.get(this.queryParameterSituationID) && search_params.get(this.queryParameterSituationID) == situation.getID() )
            	return;
        	// new value of "id" is set to "101"
        	search_params.set(this.queryParameterSituationID, situation.getID());
        	// change the search property of the main url
        	originalURL.search = search_params.toString();
			let newURL = originalURL.toString();
			//console.log("Pushing " + situation.getName() + " = " + situation.getID());
        	window.history.pushState(flux360State, situation.getName(), newURL);
		},
		housekeeping() {
			// Removing outdated events...
			const timestamp = Date.now();
			let myEvents = this.events.slice();
			myEvents.forEach( x => {
				// Check if it has timed out...
				// console.log("- Event " + x.getType() + " started " + x.getTime() + " with duration " + x.getDuration());
				if( x.getTime() + x.getDuration() < timestamp ) {
					// console.log(" timedout and will be removed");
					this.$store.commit("removeEventByID", { id: x.getID() });
				}
			});
		},
		// Synchronizes the local state over the network...
		networkSync() {
			if( this.localUser && this.localUser.ifShouldSync() ) {
				this.$store.dispatch('broadcastUserUpdate', this.localUser.getUpdatedProperties()).then( 
					x => { 
						//console.log("Synchronized " + JSON.stringify(this.localUser.getUpdatedProperties() ));
						this.localUser.resetShouldSync(); 
					} 
				);
			}
		}
	}
}
</script>